export default __webpack_public_path__ + "static/media/tab_quiz_inactive.2054960f.svg";